import axios from 'axios'; 
import { requestInter, responseInter } from './requestInter'; 
let token = localStorage.getItem('token') || '';
let headers  = {}
if(token){
    headers.Authorization = 'bearer' +token ; 
} 
let fetch = axios.create({
    // timeout: 10000,
    baseURL: '/tcmkb-api', 
    headers: headers, 
    withCredentials:true,

});

requestInter(fetch);
responseInter(fetch);
export default fetch;